import { ChakraBox } from '@equip.health/ui';

import { useGetCareTeam } from '../../../../../../lib/hooks/care-team/useGetCareTeam';
import CareTeam from '../careplan/care-team-v2/CareTeam';

interface CareTeamOverviewProps {
  patientId: string;
}

const TOP_LEVEL_ID = 'care-team-overview-v2';

const CareTeamOverview = ({ patientId }: CareTeamOverviewProps) => {
  const {
    providers,
    isLoading: isCareTeamLoading,
    treatmentEpisodeId,
  } = useGetCareTeam(patientId, true);

  return (
    <ChakraBox id={TOP_LEVEL_ID} marginTop="10px">
      <CareTeam
        hasTreatmentEpisode={!!treatmentEpisodeId}
        isLoading={isCareTeamLoading}
        patientId={patientId}
        providers={providers}
        showTags
        showTextContent
      />
    </ChakraBox>
  );
};

export default CareTeamOverview;
